// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"538":"87989e9e","650":"22236146","707":"61007d8e","761":"22236146","999":"faa6bbab"}[chunkId] + ".css";
};